var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatient = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.539 3.088c-1.928.494-3.45.883-5.539.883-2.09 0-3.611-.389-5.538-.883L0 4.494c1.385.567 2.79.97 4.246 1.467L2.77 13.677l1.627.44 1.316-4.852h.576l1.316 4.853 1.627-.441L7.754 5.96c1.455-.448 2.861-.9 4.246-1.439l-.461-1.434ZM6 3.088c-.32 0-.632-.09-.897-.26a1.561 1.561 0 0 1-.595-.693 1.48 1.48 0 0 1-.092-.892c.062-.3.216-.575.442-.79A1.64 1.64 0 0 1 5.685.03c.313-.06.638-.03.933.088.295.116.548.314.725.568.178.254.272.553.272.858 0 .41-.17.802-.473 1.091-.303.29-.714.453-1.142.453Z",
  fill: "currentColor"
})));
export default SvgPatient;